<h3>Login</h3>
<div *ngIf="!isLoggedIn">
    <button (click)="login()">Login</button>
</div>

<div *ngIf="isLoggedIn">
    <button (click)="logout()">Logout</button>
</div>